import React, {useEffect, useLayoutEffect, useCallback, useRef, useState, useMemo} from "react";
import {useLogout} from "../../api/login";
import {useDispatch, useSelector} from "react-redux";
import {useNavigateTo} from "../../hooks/useNavigateTo";
import {useTranslation} from "react-i18next";
import {setCartCount, setDrawerLogin, setDrawerSearch} from "../../reducer/actions";
import cookies from "../../utils/cookies";
import {mediaMatch} from "../../utils";

const nav = [
  {
    icon: 'lang',
  },
  {
    icon: 'search',
  },
  {
    icon: 'user',
  },
  {
    icon: 'shop',
  },
  {
    icon: 'favoriteoutline',
  }
];

const navs = [
  {
    name: '首页',
    path: '/'
  },
  {
    name: '预约服务',
    path: '/bookingList'
  },
  {
    name: '资讯分享',
    path: '/news'
  },
  {
    name: '产品分类',
    path: '/goodsList'
  },
  {
    name: '购物车',
    path: '/cart',
  },
  {
    name: '联系我们',
    path: '/callus'
  },
];

export default function Header(props) {
  const [drawerNavVisible, setDrawerNavVisible] = useState(false);
  const [drawerMyVisible, setDrawerMyVisible] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [floatHeader, setFloatHeader] = useState(false);
  const { logout } = useLogout();
  const dispatch = useDispatch();
  const state = useSelector(state => state);
  const navigateTo = useNavigateTo();
  const { t } = useTranslation();
  const headerRef = useRef(null);
  const isMdmax = mediaMatch.isMdmax;
  const agentInfo = cookies.getAgentInfo();
  const mall = cookies.get('MALL');
  
  const navHandle = (name) => {
    switch (name) {
      case 'lang':
        return;
      case 'search':
        dispatch(setDrawerSearch(true));
        return;
      case 'user':
        if (cookies.getToken()) {
          setDrawerMyVisible(true);
        } else {
          if (props.loginOpenType === 'page') {
            navigateTo('/login');
          } else {
            dispatch(setDrawerLogin(true));
          }
        }
        return;
      case 'shop':
        if (!cookies.getToken()) {
          if (props.loginOpenType) {
            navigateTo('/login');
          } else {
            dispatch(setDrawerLogin(true));
          }
        } else {
          navigateTo('/cart');
        }
        return;
      case 'favoriteoutline':
        if (!cookies.getToken()) {
          if (props.loginOpenType) {
            navigateTo('/login');
          } else {
            dispatch(setDrawerLogin(true));
          }
        } else {
          navigateTo('/wishList');
        }
        return;
      default:
    }
  };
  
  const _setDrawerNavVisible = (state) => {
    if (!cookies.getToken()) {
      return navigateTo('/login');
    } else {
      setDrawerNavVisible(state);
    }
  };
  
  const headerHandle = useCallback((e) => {
    let scrollTop = document.documentElement.scrollTop;
    setFloatHeader(scrollTop > 180 && props.type === 'home');
  }, [headerHeight]);
  
  const navBar = useMemo(() => {
    if (agentInfo.navBar) {
      let res = JSON.parse(agentInfo.navBar);
      res = res.filter(item => item.state);
      
      let hasProduct = res.find(item => item.path === '/goodsList');
      
      if (!hasProduct) {
        res = res.filter(item => item.path !== '/');
      }
      
      return res.sort((a, b) => a.sort - b.sort);
    }
    return navs;
  }, [agentInfo]);
  
  useLayoutEffect(() => {
    if (headerRef.current && headerRef.current.children[0]) {
      setHeaderHeight(headerRef.current.children[0].offsetHeight);
      document.addEventListener('scroll', headerHandle);
    }
    
    return () => {
      document.body.removeEventListener('scroll', headerHandle);
    };
  }, []);
  
  return (
    <>
      {
        props.type !== 'home' && mall !== '1'
          ? <div className="mdmax:hidden" style={{ height: headerHeight }}/> : null
      }
      <div className={`fixed w-[100%] top-0 z-50 ${props.type === 'home' ? 'fixed' : ''}`} ref={headerRef}>
        {
          props.children({
            ...props,
            nav,
            navs: isMdmax ? [...navBar, {
              name: '我的',
              nameEN:'My',
              path: '/my'
            },] : navBar,
            menus: state.myMenus,
            navHandle,
            drawerNavVisible,
            setDrawerNavVisible: _setDrawerNavVisible,
            drawerMyVisible,
            setDrawerMyVisible,
            logout,
            dispatch,
            navigateTo,
            t,
            floatHeader,
            agentInfo
          })
        }
      </div>
    </>
  );
}
